export const Product = (json: IProduct): IProductModel => {
	const fromJSON = (json: IProduct) => {
		const { created_at, updated_at, user_id, parameters, crm_id, segment, ...rest } = json
		const newParameters = parameters && Array.isArray(parameters) ? parameters.map((parameter) => ProductParameter(parameter)) : []
		const name = newParameters.find((parameter) => parameter.name === 'Model Name')?.value as string
		const brand = newParameters.find((parameter) => parameter.name === 'Brand')?.value as string
		const image = newParameters.find((parameter) => parameter.name === 'Image')?.value as string

		const filteredParameters = newParameters.filter(
			(parameter) => parameter.name !== 'Model Name' && parameter.name !== 'Brand' && parameter.name !== 'Image',
		)
		return {
			...rest,
			createdAt: created_at,
			updatedAt: updated_at,
			userID: user_id,
			parameters: filteredParameters,
			name,
			brand,
			segment: segment ? ProductSegment(segment) : segment,
			image,
			fullName: `${brand} ${name}`,
			crmID: crm_id,
		}
	}

	return { ...fromJSON(json) }
}

export const productToJSON = (obj: Partial<IProductModel>): Partial<IProduct> => {
	const { createdAt, updatedAt, userID, crmID, segment, parameters, ...rest } = obj

	return {
		...rest,
		created_at: createdAt,
		updated_at: updatedAt,
		segment: segment ? productSegmentToJSON(segment) : undefined,
		user_id: userID,
		parameters: parameters ? parameters.map((parameter) => productParameterToJSON(parameter)) : undefined,
		crm_id: crmID,
	}
}

export const UpsellProduct = (json: ISegmentUpsell): ISegmentUpsellModel => {
	const fromJSON = (json: ISegmentUpsell) => {
		const { initial_price, price_per_day, upsells, regular_price, promotional_price, ...rest } = json

		return {
			...rest,
			initialPrice: initial_price / 100,
			regularPrice: regular_price ? SegmentPrice(regular_price) : null,
			promotionalPrice: promotional_price ? SegmentPrice(promotional_price) : null,
			pricePerDay: price_per_day / 100,
			upsells: upsells ? upsells.map((upsell) => Product(upsell)) : [],
		}
	}

	return { ...fromJSON(json) }
}

export const upsellProductToJSON = (obj: Partial<ISegmentUpsellModel>): Partial<ISegmentUpsell> => {
	const { initialPrice, pricePerDay, upsells, regularPrice, promotionalPrice, ...rest } = obj

	return {
		...rest,
		initial_price: initialPrice ? initialPrice * 100 : undefined,
		regular_price: regularPrice ? segmentPriceToJSON(regularPrice) : undefined,
		promotional_price: promotionalPrice ? segmentPriceToJSON(promotionalPrice) : undefined,
		price_per_day: pricePerDay ? pricePerDay * 100 : undefined,
		upsells: upsells ? upsells.map((upsell) => productToJSON(upsell)) : [],
	}
}
